import {computed} from "vue";
import {DateTime} from "luxon";
import useUserSafe from "@/composables/useUserSafe";
import {getPreferredTimeZone} from "@/composables/selectedTimeZones";
import discounts from "@/assets/years/2026/Registration/discounts.json";
import {getEarlyBirdDates} from "@/composables/earlyBirdDates";

// The November online events' Early-Bird: the fullstack's keyDates.json "early-bird registration"
// (earlyBirdDates.js, its one source; Seán, 2026-10-29),
// open to the end of that day anywhere on Earth (UTC−12), as #register applies it (fullstack
// shared/registration/feeRules.js getIsEarlyBirdAvailable).
const YEAR = 2026;
const ZONE = "Etc/GMT+12";
const RATE = discounts["Early-bird discount"] || 0; // 0.15

// null until the dates have arrived, or without a readable date
function getEndDate() {
  const dateText = getEarlyBirdDates()?.dates || "";
  const date = DateTime.fromFormat(`${dateText} ${YEAR}`, "LLLL d yyyy", {zone: ZONE});
  return date.isValid ? date.endOf("day") : null;
}

// the price less the Early-Bird, to the nearest $5; an exact half goes down ($250 less 15% =
// $212.50 → $210), as #register and the invoice price it (fullstack feeRules.js getEarlyBirdPrice)
export function getEarlyBirdPrice(price) {
  const fives = Number(((price * (1 - RATE)) / 5).toFixed(6));
  return Math.ceil(fives - 0.5) * 5;
}

// endText: the deadline's date on the viewer's calendar (their time zone: selectedTimeZones.js),
// e.g. "13 November" in Sydney or London, as /2026's Key Dates show it (2026-10-14); the deadline
// itself never moves
export default function useEarlyBird() {
  const {user} = useUserSafe();
  const isEarlyBird = computed(() => {
    const endDate = getEndDate();
    return Boolean(endDate) && DateTime.now().setZone(ZONE) <= endDate;
  });
  const endText = computed(() => {
    const endDate = getEndDate();
    if (!endDate) return "";
    return endDate.setZone(getPreferredTimeZone(user.value)).toFormat("d LLLL");
  });
  return {isEarlyBird, endText, percent: Math.round(RATE * 100)};
}
